export const token = {
    token: "123456"
}